import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, Type, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {Document} from '../../../common/services/document/document.model';
import {
  ActionDataTable,
  ColumnDataTable,
  DataTableComponent,
  DataTableHeaderComponentService, HeaderComponent
} from '@Common/widgets/general/data-table';
import {SubSink} from '@Common/core/utils/subsink';
import {DocumentService} from '../../../common/services/document/document.service';
import {environment} from '@Env/environment';
import {Bel, BelState} from '../../../common/services/bel/bel/bel.model';
import {BoxDetailComponent} from '../../../common/components/cells-components/box-detail/box-detail.component';
import {
  FilterDirCmpDepositsComponent
} from '../../../common/components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.component';
import {FilterBaseDepositsModel} from '../../../common/components/deposit-filters/filter-base-deposits.model';
import {FilterDirCmpDepositsData} from '../../../common/components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.model';
import {DepositConservation, DepositState} from '../../../common/services/deposit/deposit.model';
import {PubSubService} from "@Common/core/services";
import {finalize} from "rxjs/operators";
import {
  FilterDepositDepositsComponent
} from "app/archivage/common/components/deposit-filters/filter-deposit-deposits/filter-deposit-deposits.component";
import {
  FilterDepositDepositsData
} from "app/archivage/common/components/deposit-filters/filter-deposit-deposits/filter-deposit-deposits.model";

export const filterDirCmpColumn = 'box__deposit__dir_cmp';
export const filterDirCmpName = 'dir_cmp_filter';

export const filterVersementColumn = 'box__deposit__deposit_identifier__in';
export const filterVersementName = 'versement_filter';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit, OnChanges {

  @Input() Bel: Bel;
  @Input() visualize = false;
  @Output() refreshEvent = new EventEmitter<boolean>();
  dsDocuments: MatDataSourceGeneric<Document> = new MatDataSourceGeneric<Document>();
  extraParams: Map<string, string> = new Map<string, string>();


  SubSink = new SubSink();
  @ViewChild('dataTable') dataTable: DataTableComponent;
  urls = {
    allDocs: `${environment.baseUrl}/api_archive/document/documents_for_elimination/`,
    belDocs: `${environment.baseUrl}/api_archive/document/`
  };
  urlListDocuments = this.urls.allDocs;
  extraDict: Map<string, string[]> = new Map<string, string[]>();

  docList: number[] = [];
  docsChecked = 0;

  toggleDUAwoDurationChecked = false;
  toggleDUAConservationChecked = false;
  toggleOnlyBELChecked = false;

  columns: ColumnDataTable[] = [
    { columnDef: filterVersementColumn, header: 'Versement',
      display: (element: Document) => `${element.box_obj.deposit_obj.deposit_identifier || ''}`,
      tooltip: (element: Document) => `${element.box_obj.deposit_obj.deposit_identifier || ''}`,
      headerFilterToolTip: (element: Document) => 'Filtrer sur des versements',
      colorBackground: this.coloBgWoDua,
      sort: false, flex: 10
    },
    { columnDef: 'instruction', header: 'Instruction',
      display: (element: Document) =>  element.dua_obj.instruction_obj.label,
      tooltip: (element: Document) => element.dua_obj.instruction_obj.label,
      colorBackground: this.coloBgWoDua,
      sort: false, flex: 30
    },
    { columnDef: 'nature', header: 'Nature',
      display: (element: Document) => element.dua_obj?.nature,
      tooltip: (element: Document) => element.dua_obj?.observation,
      colorBackground: this.coloBgWoDua,
      sort: false, flex: 50
    },
    { columnDef: 'box_number', header: 'Boîte',
      display: (element: Document) => `${element.box}`,
      tooltip: (element: Document) => `${element.box}`,
      colorBackground: this.coloBgWoDua,
      sort: false, flex: 10,
    },
    { columnDef: filterDirCmpColumn, header: 'Entité',
      display: (element: Document) => `${element.dir_cmp_archive_obj?.acronym || element.dir_cmp_archive_obj?.entite_archivage_obj?.entite_obj?.name}`,
      tooltip: (element: Document) => `${element.dir_cmp_archive_obj?.acronym} / ${element.dir_cmp_archive_obj?.entite_archivage_obj?.entite_obj?.name}`,
      headerFilterToolTip: () => `Filtrer sur une direction / composante`,
      colorBackground: this.coloBgWoDua,
      sort: false,
    },
  ];
  actions: ActionDataTable[] = [
    { label: 'Ajouter/Supprimer', tooltip: 'Ajouter/Supprimer ce document à ce BEL',  icon: 'check_box_outline_blank',
      tooltipfct: () => null,
      iconfct: (row: Document) => (row.bel === this.Bel?.id ? 'check_box' : 'check_box_outline_blank'),
      hiddenHeader: () => false,
      hidden: () => !this.showIfFirstState(),
      colorBackground: this.coloBgWoDua,
      click: (row) => this._updateDocument(row),
    },
  ];
  subSink = new SubSink();
  constructor(
    private documentSvc: DocumentService,
    private dataTableHeaderSvc: DataTableHeaderComponentService,
    private pubSubSvc: PubSubService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.getBelDocs();
  }

  ngOnInit(): void {
    this._initFilters();
    this.extraParams.set('bel_id', this.Bel.id.toString());
    this.dsDocuments.daoService = this.documentSvc;
    this._getDocsList();
    this._setCellBox();

    if (this.visualize) {
      this.toggleOnlyBELChecked = true;
    }
  }
  private _initFilters() {
    this._setFilter(this.columns, FilterDirCmpDepositsComponent,
      filterDirCmpColumn, filterDirCmpName, 'entité',
      [DepositState.ARCHIVED],
      this._setExtraParamsDirCmp, this._setRazExtraParams, () => this.dataTableReload());
    this._setFilter(this.columns, FilterDepositDepositsComponent,
      filterVersementColumn, filterVersementName, 'versement',
      '',
      this._setExtraParamsDeposit, this._setRazExtraParams, () => this.dataTableReload());
  }
  private _setExtraParamsDirCmp(data: FilterDirCmpDepositsData, column, extraParams) {
    extraParams.set(column, data.value.id.toString());
  }
  private _setExtraParamsDeposit(data: FilterDepositDepositsData, column, extraParams) {
    extraParams.set(column, data.value);
  }
  private _setRazExtraParams(data, column, extraParams) {
    extraParams.delete(column);
  }
  private dataTableReload() {
    if (this.dataTable) {
      this.dataTable.reload();
      this._getDocsList();
    }
  }
  private _setFilter(columns: ColumnDataTable[],
                     componentFilter: Type<HeaderComponent>,
                     columnFilter: string,
                     filterName: string, filterTitle: string,
                     data: any,
                     callBackValidate: Function,
                     callBackRaz: Function,
                     callBackAction: Function = null) {
    const filterComponent = this.dataTableHeaderSvc.createHeaderComponent(columns,
      columnFilter, filterName, filterTitle,
      componentFilter, data, true);
    if (filterComponent && filterComponent.subject$) {
      this.subSink.sink = filterComponent.subject$.subscribe((_data: FilterBaseDepositsModel) => {
        if (_data) {
          if (_data.action === 'validate') {
            filterComponent.data = _data.value;
            if (_data.value) {
              callBackValidate.call(null, _data, columnFilter, this.extraParams);
            }
          }
          if (_data.action === 'reinit') {
            filterComponent.data = null;
            callBackRaz.call(null, _data, columnFilter, this.extraParams);
          }
          if (callBackAction) {
            callBackAction.call(null, null);
          }
        }
      });
    }
  }

  coloBgWoDua(doc: Document) {
    if ([DepositConservation.INTEGRAL, DepositConservation.SCAN].includes(doc?.dua_obj?.final_fate)) {
      return '#fa0000';
    }
    if (doc?.dua_obj?.without_duration) {
      return '#fac8c8';
    }
    return '#ffffff';
  }

  showIfFirstState(): boolean{
    return this.Bel.state == BelState.CONSTITUTION_REVISION && !this.visualize;
  }

  massUpdate() {
    this.pubSubSvc.publish('loading', true);
    const check_all = this.docList.length !== this.docsChecked;
    this.subSink.sink = this.documentSvc.massUpdate(this.Bel, this.docList, check_all).pipe(
      (finalize(()=> this.pubSubSvc.publish('loading', false)))
    ).subscribe((_data)=>{
      this.Bel.documents_obj = _data.documents_obj;
      this.dataTableReload();
    })
  };

  /**
   * Détail de la Boite
   * @private
   */
  private _setCellBox() {
    this.dataTableHeaderSvc
      .createColumnComponent(
        this.columns, 'box_number', `Boite`, `Détail de la boite`,
        BoxDetailComponent, null);
  }

  private _updateDocument(document: Document): void {
    this.pubSubSvc.publish('loading', true);
    document.bel = (!document.bel ? this.Bel?.id : null);
    this.SubSink.sink = this.documentSvc.update(document).pipe(
        (finalize(()=> this.pubSubSvc.publish('loading', false)))
      ).subscribe((_data) => {
      if (document.bel) {
        this.Bel.documents_obj.push(document);
        ++this.docsChecked;
      } else {
        this.Bel.documents_obj = this.Bel.documents_obj.filter(doc => doc.id !== document.id);
        --this.docsChecked;
      }
      this.refreshEvent.emit(true);
      // Force reload suivant les cas
      if (!document.bel) {
        // force reload si le document est enlevé
        if (document.dua_obj.without_duration) {
          // si sa dua est sans durée
          if (!this.toggleDUAwoDurationChecked || this.toggleOnlyBELChecked) {
            // si on affiche uniquement les docs du BEL ou si on n'affiche pas les DUA sans durée
            this.dataTableReload();
          }
        } else if ([DepositConservation.INTEGRAL, DepositConservation.SCAN].includes(document.dua_obj.final_fate)) {
          // si sa dua est conservation ou scan
          if (!this.toggleDUAConservationChecked || this.toggleOnlyBELChecked) {
            // si on affiche uniquement les docs du BEL ou si on n'affiche pas les DUA conservation
            this.dataTableReload();
          }
        }
      }
    });
  }

  private _getDocsList(): void {
    this.dsDocuments.listData$.subscribe((_data: Document[])=> {
      this.docList = [];
      this.docsChecked = 0;
      _data.filter((x)=> {
        this.docList.push(x.id);
        (x.bel?++this.docsChecked:'');
      });
    });
  }

  toggleDUAwoDuration(checked: boolean) {
    this.toggleDUAwoDurationChecked = checked;
    this.getBelDocs();
  }
  toggleDUAConservation(checked: boolean) {
    this.toggleDUAConservationChecked = checked;
    this.getBelDocs();
  }
  toggleOnlyBEL(checked: boolean) {
    this.toggleOnlyBELChecked = checked;
    if (checked) {
      this.toggleDUAwoDurationChecked = false;
      this.toggleDUAConservationChecked = false;
    }
    this.getBelDocs();
  }
  getBelDocs(): void {
    const showDocs = !this.toggleOnlyBELChecked && this.showIfFirstState();

    this.extraParams.delete('bel');
    this.extraParams.delete('bel_id');
    this.extraParams.delete('without_duration');
    this.extraParams.delete('dua_conservation');
    if (showDocs) {
      this.extraParams.set('bel_id', this.Bel.id.toString());
      this.extraParams.set('without_duration', this.toggleDUAwoDurationChecked.toString());
      this.extraParams.set('dua_conservation', this.toggleDUAConservationChecked.toString());
    } else {
      this.extraParams.set('bel', this.Bel.id.toString());
    }

    this.urlListDocuments = showDocs ? this.urls.allDocs : this.urls.belDocs;
    this.dataTableReload();
  }

}
